/**
 * React Query hook for fetching similar opportunities
 */ import { useQuery } from '@tanstack/react-query';
import { opportunityApiConnect } from '../../../lib/api/opportunityApi.connect';
export function useSimilarOpportunities(noticeId, enabled = true, limit = 5) {
    return useQuery({
        queryKey: [
            'opportunities',
            'similar',
            noticeId,
            limit
        ],
        queryFn: ()=>opportunityApiConnect.getSimilarOpportunities(noticeId, limit),
        enabled: !!noticeId && enabled,
        staleTime: 5 * 60 * 1000
    });
}
